import atom from '@tencent/vft-atom';
import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import { getUrlParam } from '@tencent/vft-common/util';

import { md5 } from 'js-md5';

export function testAlert(tag, value) {
  if (window.location.search.indexOf('debuger=1') > -1) {
    let str = `${tag}: `;
    if (typeof value === 'string') {
      str += `[string] ${value}`;
    } else {
      str += `[object] ${JSON.stringify(value)}`;
    }
    alert(str);
  }
}
const getScript = (() => {
  const cache = new WeakMap();
  const loadScript = (src) => {
    const script = document.createElement('script');
    const load = new Promise((resolve, reject) => {
      script.async = 'async';
      script.src = src;
      script.setAttribute('loaded-by', 'getScript');
      script.onload = resolve;
      script.onerror = () => {
        document.head.removeChild(script);
        reject('load script error');
      };
      document.head.appendChild(script);
    });
    cache.set(script, load);
    return load;
  };
  return (src) => {
    // 查看此脚本是否已加载
    const existScript = document.querySelector(`[src=${JSON.stringify(src)}]`);
    if (existScript) {
      // 若已存在, 且在加载缓存中，则等待加载完成
      if (cache.get(existScript)) {
        return cache.get(existScript);
      }
      // 若不在加载缓存中，则有可能不是通过此函数进行加载/页面已加载等，情况比较多，无法确保可用性，用此函数重新加载一次
    }
    return loadScript(src);
  };
})();
let wetvshield;

export const callShield = async (res) => {
  if (!wetvshield) { // 创建单例
    // 开启防水墙策略
    await getScript('https://vm.gtimg.cn/tencentvideo_v1/script/film/weixin/v3/lib/vftshield.min.js?max_age=2592000');
    wetvshield = new window.VftShield();
  }
  let param;// 拉起防水墙组件的入参
  if (typeof res.safe_result === 'string') {
    const result = decodeURIComponent(res.safe_result);
    param = JSON.parse(result);
  }
  return new Promise((resolve, reject) => {
    try {
      wetvshield.setStrategy(param);
      wetvshield.run().then(
        () => resolve(),
        (error) => {
          reject(error);
        },
      );
    } catch (error) {
      reject(error);
    }
  });
};

export function checkAndApplyDarkMode() {
  // web端使用dark模式
  if (getUrlParam('dark-mode') === '1' || env.isWeb) {
    return document?.documentElement?.classList.add('__darkmode__');
  }
  atom.invoke('webViewDarkMode').then(({ isDarkMode }) => {
    if (isDarkMode === '1') {
      document?.documentElement?.classList.add('__darkmode__');
    }
  });
}

export const loadQimeiLib = () => getScript('https://staticfile.qq.com/qimei/qimeisdk-web/fo/0.5.8/index.js?appKey=9d927004c0b73a8b');

export const getQimeiSign = async (url) => {
  let h38 = cookie.get('h38');
  const qimeiWeb = window.qimeiWeb;
  if (!h38) {
    h38 = qimeiWeb.getLocalQimei36()?.h38 || '';
    cookie.set('h38', h38, {
      domain: '.wetv.vip',
    });
  }
  // 加载md5库
  const guid = window.wetvLogin?.userInfo?.guid || '';
  const signVal = md5(`h38=${h38.toLowerCase()}&guid=${guid.toLowerCase()}&cgi=${url.split('?')[0]?.toLowerCase() || ''}`);

  // 根据请求的url进行签名
  return await qimeiWeb.sign(signVal, Date.now(), false);
};
